<template>
  <content-panel class="maintenance-page">
    <template v-slot:search>
      <search-box class="search-box">
        <el-form
          :model="filter"
          inline
          size="mini"
          label-width="110px"
          @submit.native.prevent="search"
        >
          <el-form-item label="包件">
            <el-input
              v-model.trim="filter.packKeyword"
              clearable
              placeholder="编码或名称模糊查询"
              @keyup.enter.native="search"
            />
          </el-form-item>
          <el-form-item label="店铺简称">
            <el-input
              v-model.trim="filter.storeShortName"
              clearable
              placeholder="精确查询"
              @keyup.enter.native="search"
            />
          </el-form-item>
        </el-form>

        <template v-slot:right>
          <el-button type="primary" size="small" :loading="loading" @click="search">
            查询
          </el-button>
          <el-button class="orange-btn" size="small" @click="reset">
            重置
          </el-button>
        </template>
      </search-box>
    </template>

    <template v-slot:sub>
      <el-alert
        title="京东入仓需求数据将在下一个发货周期计算版本中生效。"
        type="info"
        :closable="false"
        show-icon
      />
      <el-alert v-if="error" :title="error" type="error" :closable="false">
        <el-button type="text" @click="initialize">重新加载</el-button>
      </el-alert>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-left>京东入仓需求</template>
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="importVisible = true">
          批量导入
        </el-button>
        <el-button size="mini" @click="downLoadTemplate">
          下载模板
        </el-button>
      </template>

      <el-table
        v-loading="loading"
        :data="rows"
        :height="maxTableHeight"
        border
        size="small"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        empty-text="暂无符合条件的记录"
        element-loading-text="数据加载中"
      >
        <el-table-column
          prop="packCode"
          label="包件编码"
          min-width="160"
          show-overflow-tooltip
        />
        <el-table-column
          prop="packName"
          label="包件名称"
          min-width="220"
          show-overflow-tooltip
        />
        <el-table-column
          prop="demand30d"
          label="未来30天入仓需求"
          min-width="180"
          align="center"
        />
        <el-table-column
          prop="storeShortName"
          label="店铺简称"
          min-width="160"
          show-overflow-tooltip
        />
        <el-table-column prop="operatorName" label="操作人" width="120" />
        <el-table-column prop="operateTime" label="操作时间" min-width="180" />
      </el-table>

      <template v-slot:footer>
        <div class="jd-demand-pagination">
          <el-pagination
            :current-page.sync="page"
            :page-size.sync="size"
            :total="total"
            :page-sizes="[10, 30, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            background
            @size-change="search"
            @current-change="load"
          />
        </div>
      </template>
    </table-panel>

    <import-dialog
      v-if="importVisible"
      :visible.sync="importVisible"
      title="京东入仓需求导入"
      report-name="deliveryCycleJdDemandImport"
      @refresh="search"
    />
  </content-panel>
</template>

<script>
import axios from '@/utils/axiosInstance'
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'
import { errorText, pageRequest, responseData } from './model'
import ImportDialog from './components/ImportDialog'

const emptyFilter = () => ({
  packKeyword: '',
  storeShortName: ''
})

export default {
  name: 'JdWarehouseDemand',
  mixins: [pagePathMixin, tableMixin],
  components: { ImportDialog },
  data () {
    return {
      filter: emptyFilter(),
      applied: {},
      rows: [],
      total: 0,
      page: 1,
      size: 10,
      loading: false,
      error: '',
      requestId: 0,
      importVisible: false,
      templateData: ''
    }
  },
  created () {
    this.getTemplate()
    this.initialize()
  },
  beforeDestroy () {
    this.requestId++
  },
  methods: {
    async initialize () {
      this.filter = emptyFilter()
      this.page = 1
      await this.search()
    },
    search () {
      this.applied = {
        packKeyword: this.filter.packKeyword,
        storeShortName: this.filter.storeShortName
      }
      this.page = 1
      return this.load()
    },
    reset () {
      this.filter = emptyFilter()
      this.search()
    },
    async load () {
      const id = ++this.requestId
      this.loading = true
      this.error = ''

      try {
        const data = responseData(
          await this.$q.shippingPeriod.jd({
            data: pageRequest(this.page, this.size, this.applied)
          })
        )

        if (id === this.requestId) {
          this.rows = data.records || []
          this.total = Number(data.total) || 0
        }
      } catch (error) {
        if (id === this.requestId) {
          this.rows = []
          this.total = 0
          this.error = errorText(error)
        }
      } finally {
        if (id === this.requestId) {
          this.loading = false
        }
      }
    },
    async getTemplate () {
      const res = await axios.get(
        '/qu-platform-excel-api/excel/cfg/getTemplate/deliveryCycleJdDemandImport'
      )
      this.templateData = res.data
    },
    downLoadTemplate () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        this.downLoad(this.templateData.templatePath, `${this.templateData.fileName}.XLSX`)
        loading.close()
      }, 300)
    },
    downLoad (path, name) {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', path, true)
      xhr.responseType = 'blob'
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(xhr.response, name)
          } else {
            const link = document.createElement('a')
            const body = document.querySelector('body')
            link.href = window.URL.createObjectURL(xhr.response)
            link.download = name
            link.style.display = 'none'
            body.appendChild(link)
            link.click()
            body.removeChild(link)
            window.URL.revokeObjectURL(link.href)
          }
        }
      }
      xhr.send()
    }
  }
}
</script>

<style src="./style.css"></style>

<style scoped>
.jd-demand-pagination {
  text-align: right;
}
</style>
